import {setEventPreventHidingEditTaskSlidingPanel} from "../../panels/utils"
import $ from "jquery"
import {bindActionCreators} from 'redux'
import {connect} from "../../redux/utils"
import TaskStore from "../../store/TaskStore"
import LockTTStore from "./LockTTStore"
import User from "../../store/User"
import messageResource from "../../messageResource"
import {atImgPath} from "../../atBrowserUtils"
import makeRpcCall from "../../util/jquery_rpc"
import LoadingMoire from "../../LoadingMoire"
import LockTTTableController from "./LockTTTableController"
import {getOpenTaskId} from '../../panels/task/editPanel/selectors'
import {openEditTaskPanel} from '../../panels/task/editPanel/actions'
import TimeTrackPageFeatureDiffController from '../TimeTrackPageFeatureDiffController'
import View from '../../View'
import EditTaskPanelContainer from '../components/EditTaskPanelContainer'
import { toast } from "../../toasts/actions"

class LockTTMediator extends View {
    constructor({
        openTaskPanel = taskId => {},
        toast = () => {},
    }) {
        super()

        this.actions = {
            openTaskPanel,
            toast,
        }

        this.state = {
            openTaskId: null,
        }

        this.onStatePropertyChanged('openTaskId', this._updateTaskSelection)
    }

    init(config)
    {
        super.init()
        this._initModel();
        this._setStore(config);
        this._initControls();
        this._initCallbacks();
        this._toggleFirstLoad(true);

        this.loadData();
        this._update();
    }

    _setStore(config)
    {
        LockTTStore.setDateFormat(config.dateFormat);
        LockTTStore.setDateRangeConfig(config.dateRangeConfig);
        LockTTStore.setEnabledFeatures(config.enabledFeatures);
        LockTTStore.setUsersSelectorConfig(config.userSelectorConfig);
        LockTTStore.setSortingOrder(config.sortingOrder);
        LockTTStore.setPagerConfig(config.pagerConfig);
        LockTTStore.setSelectionVeilImages(config.selectionVeilImages);
        LockTTStore.setUsersForSelector(config.usersForSelector);
        LockTTStore.setTimeZonesForSelector(config.timeZonesForSelector);
        LockTTStore.setUsersGroupsForSelector(config.usersGroupsForSelector);
        LockTTStore.setFeaturesForSelector(config.usersGroupFeature, config.timeZoneGroupFeature);
        LockTTStore.setCalendarConfig(config.calendarConfig);
        LockTTStore.setHideDetailsOnLockTT(config.hideDetailsOnLockTT);
    }

    _initControls()
    {
        this.configurationPanel = new LockTTPage.ConfigurationPanel($("#lockTableFilter")).init();
        this.filterController = new LockTTPage.FilterController().init();


        this.pager = new LockTTPager($("#pagerPlaceholder"), LockTTStore.getPagerConfig().selectOptions).init();
        this.pager.hide();

        this.topInfo = new LockTTTopInfo($("#topInfoPlaceHolder")).init();
        this.topInfo.hide();

        this.tableController = new LockTTTableController().init();
        this.moire = new LoadingMoire({
                    lines: 12,
                    length: 9,
                    width: 5,
                    radius: 11
                }).init($('.lockTableWrapper'))

        this.UGREnabled = LockTTStore.getUserGroupFeatureForSelector();
        this.TZGEnabled = LockTTStore.getTimeZoneGroupFeatureForSelector();

        new EditTaskPanelContainer({
            onTaskDeletedCb: (taskId) => this.loadData(),
        }).init()
    }

    _initModel()
    {
        this.page = new LockTTPage($("#pageContent")).init();
        new TimeTrackPageFeatureDiffController().init()
    }

    _shiftDateRange(milliseconds)
    {
        var dateRangeConfig = LockTTStore.getDateRangeConfig();
        var newDateRangeConfig = {
            qualifier: "CUSTOM",
            fromDate: new Date(dateRangeConfig.fromDate.getTime() + milliseconds),
            toDate: new Date(dateRangeConfig.toDate.getTime() + milliseconds)
        };
        LockTTStore.setDateRangeConfig(newDateRangeConfig);
    }

    _initCallbacks()
    {
        var self = this;
        // configuration panel
        $("#clearButton").click(function()
                                {
                                    self.filterController.setUserSelection(UserSelectionUtils.defaultUserSelector());
                                    $(document).trigger("usersSelector.changed");
                                });

        $(document).on("dateRangeSelector.changed", function(e, dateRange)
        {
            LockTTStore.setDateRangeConfig(dateRange);
            self.loadData();
            self.configurationPanel.update();
        });

        $(document).on("usersSelector.changed", function()
        {
            var userSelection = self.filterController.getUserSelection();
            var prevUserSelection = LockTTStore.getUsersSelectorConfig();
            LockTTStore.setUsersSelectorConfig(self.filterController.getUserSelection());

            if (!UserSelectionUtils.empty(userSelection) && !UserSelectionUtils.equals(prevUserSelection, userSelection))
            {
                self.loadData();
            }
            self._update();
        });

        // action for table
        $(document).on("navigate.previous_week", function()
        {
            var week = 7 * 24 * 60 * 60 * 1000;
            self._shiftDateRange(-week);
            self.loadData();
            $(document).trigger("updateDateRange");
        });

        $(document).on("navigate.next_week", function()
        {
            var week = 7 * 24 * 60 * 60 * 1000;
            self._shiftDateRange(week);
            self.loadData();
            $(document).trigger("updateDateRange");
        });

        $(document).on("navigate.till_lock_date", function()
        {
            var day = 24 * 60 * 60 * 1000;
            var tillLockDate = LockTTStore.getLockedTillDate();
            var fromDate = LockTTStore.getDateRangeConfig().fromDate;
            self._shiftDateRange(tillLockDate.getTime() - 2 * day - fromDate.getTime());
            self.loadData();
            $(document).trigger("updateDateRange");
        });

        $(document).on("lock.submitted", function(e, actionParameters)
        {
            self.loadData(actionParameters);
        });

        $(document).on("order.changed", function(e, sortingOrder)
        {
            LockTTStore.setSortingOrder(sortingOrder);
            self.loadData();
        });

        $(document).on("pager.records_per_page.change", function(e, recordsPerPage)
        {
            LockTTStore.getPagerConfig().recordsPerPage = recordsPerPage;
            self.loadData();
        });

        $(document).on("pager.shown_record.change", function(e, shownRecord)
        {
            LockTTStore.getPagerConfig().shownRecord = shownRecord;
            self.loadData();
        });

        $(document).on("lockTT_table_taskClick", function(e, clickEvent, taskId) {
            setEventPreventHidingEditTaskSlidingPanel(clickEvent)
            self.actions.openTaskPanel(taskId)
        })

        $(document).on('editTaskPanel_updateTask', (e, {taskId, prevTaskState}) => {
            this._onTaskChanged(taskId, prevTaskState)
        })

        $(document).on('task_added_to_timesheet_event', (_, hasError) =>
            hasError
                ? alert(messageResource.getMessage("api.error.unexpected_error"))
                : this.actions.toast(messageResource.getMessage("add_to_timesheet.tasks.toast"))
        )
    }

    _updateTaskSelection = (taskId) => {
        let $lockTablePlaceholder = $("#lockTablePlaceholder")
        $lockTablePlaceholder.find(".TaskCell.editing").removeClass("editing")
        if (taskId) {
            $lockTablePlaceholder
                .find(".TaskCell")
                .filter((index, taskCell) => taskCell.cellObj.value.id === taskId)
                .addClass("editing")
        }
    }

    loadData(customActionParameters)
    {
        descriptionPopup.hide();
        this.moire.find(".spinnerPlaceholder").css("margin-top", ($(".lockTableWrapper").height() / 2) + "px");
        this.moire.show();

        var actionParameters = {
            pageAction: "navigate",
            lockUnlockMode: null,
            lockUnlockFromDate: null,
            lockUnlockToDate: null
        };
        actionParameters = _.extend(actionParameters, customActionParameters);

        if (this.rpc)
        {
            this.rpc.abort();
        }
        var userSelectorConfig = LockTTStore.getUsersSelectorConfig();
        var dateRangeConfig = LockTTStore.getDateRangeConfig();
        var dateFormat = LockTTStore.getDateFormat();
        this.rpc = makeRpcCall("LockTTService.getLockTTData",
                               [
                                   actionParameters.pageAction,
                                   userSelectorConfig.allUsers,
                                   userSelectorConfig.selectedUsers,
                                   userSelectorConfig.showDisabled,
                                   userSelectorConfig.groupType,
                                   userSelectorConfig.selectedGroups,
                                   LockTTStore.getSortingOrder(),
                                   actionParameters.lockUnlockMode,
                                   actionParameters.lockUnlockFromDate,
                                   actionParameters.lockUnlockToDate,
                                   LockTTStore.getPagerConfig().shownRecord,
                                   LockTTStore.getPagerConfig().recordsPerPage,
                                   dateFormat.formatDate(dateRangeConfig.fromDate),
                                   dateFormat.formatDate(dateRangeConfig.toDate),
                                   DateRangeStateUtil[dateRangeConfig.qualifier]
                               ],
                               _.bind(this._loadDataSuccess, this),
                               _.bind(this._loadDataFail, this));
    }

    _updateMessages(messages, errors)
    {
        var $container = $(".messagesBottomMargin");
        $container.empty();
        var hasMessages = messages && messages.length > 0;
        var hasErrors = errors && errors.length > 0;
        if (hasMessages || hasErrors)
        {
            var data = {
                messages: messages,
                errors: errors,
                hasMessages: hasMessages,
                hasErrors: hasErrors,
                hasWarnings: false,
                hasAdditionalError: false,
                successImg: atImgPath("success.gif"),
                errorImg: atImgPath("error.gif")
            };
            new LockTTMessages($container, data).init();
        }
    }

    _validateLeaveTypes(data)
    {
        return _.every(data.userDataGroups, function(userGroupData)
        {
            return _.every(userGroupData.usersData, function(userData)
            {
                return _.every(userData.leaveTypes, function(leaveType)
                {
                    return LeaveTypeUtil.validateLeaveType(leaveType);
                })
            })
        })
    }

    _validateGroupFeatures(enabledFeatures)
    {
        if (this.UGREnabled != !!enabledFeatures.UGR)
        {
            this._showAlertAboutFeatureOnOffAndReloadPage(this.UGREnabled, messageResource.getMessage("common.User_Groups"));
            return false;
        }
        else if (this.TZGEnabled != !!enabledFeatures.TZG)
        {
            this._showAlertAboutFeatureOnOffAndReloadPage(this.TZGEnabled, messageResource.getMessage("common.Time_Zone_Groups"));
            return false;
        }
        return true;
    }

    _showAlertAboutFeatureOnOffAndReloadPage(oldFeatureStateOn, featureText)
    {
        alert(messageResource.getMessage(oldFeatureStateOn ? "common.turned_off_functionality" : "common.enabled_functionality", [featureText]));
        window.location.reload();
    }

    _prepareAndSetDataIntoStore(data)
    {
        var needReload = !this._validateLeaveTypes(data) || !this._validateGroupFeatures(data.enabledFeatures);
        if (needReload) return false;

        LockTTStore.setPagerConfig(data.pagerInfo);
        LockTTStore.setEnabledFeatures(data.enabledFeatures);
        LockTTStore.setLockedTillDate(_.isNull(data.allLockedTillDate) ? null : Date.parseJSONDate(data.allLockedTillDate));
        LockTTStore.setAllLockedTillDateBeyondDateRange(_.isNull(data.allLockedTillDateBeyondDateRange) ? null : Date.parseJSONDate(data.allLockedTillDateBeyondDateRange));
        LockTTStore.setDeletedUsers(this._createUserArray(data.deletedUsers));
        LockTTStore.setUsers(this._createUserArray(data.users));
        LockTTStore.setTimestamp(data.timestamp);
        LockTTStore.setWeekStartDay(data.weekStartDay);
        LockTTStore.setLoggedInUserToday(Date.parseJSONDate(data.today));
        LockTTStore.setSortingOrder(data.order);
        LockTTStore.setDisabledUsersSelected(data.disabledUsersSelected);
        LockTTStore.setMonths(data.months);

        _.each(data.headerData, function(headerData)
        {
            headerData.date = Date.parseJSONDate(headerData.date);
        });
        LockTTStore.setHeaderData(data.headerData);

        LockTTStore.setDateRangeConfig({
                                           "fromDate": Date.parseJSONDate(data.fromDate),
                                           "toDate": Date.parseJSONDate(data.toDate),
                                           "qualifier": _.invert(DateRangeStateUtil)[data.qualifier]
                                       });

        LockTTStore.setUserDataGroups(data.userDataGroups);
        return true;
    }

    _loadDataSuccess(data)
    {
        if (!this._prepareAndSetDataIntoStore(data)) return;

        var $tableContainer = $("#lockTablePlaceholder");
        $tableContainer.empty();
        var $emptyTable = $("#emptyTable");
        $emptyTable.empty();
        if (LockTTStore.getPagerConfig() && LockTTStore.getPagerConfig().recordsNumber > 0)
        {
            this.tableController.createLockTable($tableContainer[0], _.bind(this._onLockedTillDateChange, this));
            $(document).trigger("data.loaded");
        }
        else
        {
            new LockTTEmptyTable($emptyTable).init();
            $(document).trigger("data.empty");
        }
        this.pager.update();
        this.topInfo.update();
        this._updateMessages(data.messages, data.errors);
        this._toggleFirstLoad(false);
        this.moire.hide();
    }

    _loadDataFail(data)
    {
        this._toggleFirstLoad(false);
        this.moire.hide();
        $(document).trigger("data.loaded.fail");
    }

    _createUserArray(users)
    {
        var array = [];
        _.each(users, function(user)
        {
            array.push(new User(user.id, user.firstName, user.lastName, user.middleName, user.username, user.activeInAt, user.hasEmail, user.userGroupId, user.timeZoneGroupId));
        });
        return array;
    }

    _onLockedTillDateChange(date)
    {
        LockTTStore.setLockedTillDate(date);
        this.topInfo.updateTillDate();
    }

    _update()
    {
        const chooseUserButton = $(".chooseUserButton")
        const filterButton = $(".chooseUserButton .commonVisibleFilterButton")
        const clearButton = $("#clearButton")
        chooseUserButton.removeClass("emptySelector")
        filterButton.removeClass("filtered")
        clearButton.removeClass()

        const userSelection = LockTTStore.getUsersSelectorConfig()

        this.filterController.setErrorTooltipEnabled(UserSelectionUtils.empty(userSelection));
        if (UserSelectionUtils.empty(userSelection))
        {
            chooseUserButton.addClass("emptySelector")
            filterButton.addClass("filtered")
            clearButton.addClass("enabled")
        }

        if (!UserSelectionUtils.equals(userSelection, UserSelectionUtils.defaultUserSelector()))
        {
            filterButton.addClass("filtered")
            clearButton.addClass("enabled")
        }

        this.configurationPanel.update();
    }

    _toggleFirstLoad(value)
    {
        $(".lockTableWrapper").toggleClass("firstLoad", value);
    }

    _onTaskChanged(taskId, prevTaskState) {
        var task = TaskStore.get(taskId);
        if (!task)
            return
        if (prevTaskState.name !== task.name || prevTaskState.workflowStatusId !== task.workflowStatusId
            || prevTaskState.commentsNumber !== task.commentsNumber) {
            this.tableController._updateTask(task);
        }

        this._updateTaskSelection(this.state.openTaskId)
    }
}

export default connect(
    state => ({
        openTaskId: getOpenTaskId(state),
    }),
    dispatch => ({
        openTaskPanel: bindActionCreators(openEditTaskPanel, dispatch),
        toast: bindActionCreators(toast, dispatch),
    })
)(LockTTMediator)


// WEBPACK FOOTER //
// ./web/js/user/locktt/LockTTMediator.js